var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-form"},[_c('app-form',{attrs:{"formName":"Contact","formTemplate":"contact","subject":"Questions et commentaires","toEmail":_vm.data.email,"successText":_vm.successText}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }